import React, { useState,useEffect } from "react";
import AdminHeader from "../AdminHeader/AdminHeader";
import SideBarAdmin from "../SideBarAdmin/SideBarAdmin";
import AddVehicleDrawer from "./AddVehicleDrawer";
import TableDateAdminVehicle from "./TableDateAdminVehicle";
import "./VehiclesAdmin.css";
import { useDispatch } from "react-redux";
import { getAllDrivers } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";

import { addVehicle } from "../../redux/AdminReducer";

const VehiclesAdmin = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );

  const dispatch=useDispatch();

  let tempArray=[];
 const filterDrivers= driversData.map((item)=>{
    if(item.assigned===false)
    {
      if(item != undefined)
      {
        tempArray.push(item);
        return item
      }
    

     

    }

   

  })

console.log("filterDrivers",filterDrivers,driversData,tempArray)


  console.log("driversData",driversData)
  useEffect(() => {
    dispatch(getAllDrivers());

  }, []);


  return (
    <>
      <AdminHeader rightHeader={rightHeader} />

      <div className="topSideVehicles">
        <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        />
        <div className="vehicleAdminMain">
          <div className="topTextEditAdmVehic">
            You can see and edit detail about vehicles here..
          </div>

          <div className="topTextsVehiclAdmin">
            <div className="topInputBtnSearch">
              <input placeholder="Search Vehicle" className="inputSearchVehic" />
              <button className="btnSearchVehicle">Search</button>
            </div>

            <div  className="topAddVehicleDrawer">
              <AddVehicleDrawer
              driverData={tempArray}
              />
              {/* Add vehicle */}
            
            
            </div>
          </div>
         <div className="topTableAdminVehicles">
         <TableDateAdminVehicle
             driverData={tempArray}
         />
         </div>
        </div>
      </div>
      {/* <div style={{marginTop:"100px"}}>
        hfgjhdfg
      </div> */}
    </>
  );
};

export default VehiclesAdmin;
